import React from 'react';

import type { FormatXMLElementFn } from 'intl-messageformat';
import { Text } from '@atlaskit/primitives/compiled';
import Link from '@atlaskit/link';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

export interface LegalNoticeProps {
	onRenderLegalText?: (legalText: string) => void;
}

const CUSTOMER_AGREEMENT_URL = 'https://www.atlassian.com/legal/atlassian-customer-agreement';
const PRIVACY_POLICY_URL = 'https://www.atlassian.com/legal/privacy-policy';

export const legalNoticeOverrides = {
	tc: (...args) => {
		const onClick: (
			e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
			analyticsEvent: UIAnalyticsEvent,
		) => void = (e, analyticsEvent) => {
			fireUIAnalytics(analyticsEvent, 'customerAgreementUrl');
		};

		return (
			<Link
				href={CUSTOMER_AGREEMENT_URL}
				target="_blank"
				rel="noopener noreferrer"
				onClick={onClick}
			>
				{args}
			</Link>
		);
	},
	pp: (...args) => {
		const onClick: (
			e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
			analyticsEvent: UIAnalyticsEvent,
		) => void = (e, analyticsEvent) => {
			fireUIAnalytics(analyticsEvent, 'privacyPolicyUrl');
		};

		return (
			<Link href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" onClick={onClick}>
				{args}
			</Link>
		);
	},
} satisfies Record<string, FormatXMLElementFn<React.ReactNode>>;

export const LegalNotice = () => {
	const { formatMessage } = useIntl();

	return (
		<Text color="color.text.subtle" size="small">
			{formatMessage(messages.trialInfo, legalNoticeOverrides)}
		</Text>
	);
};
